import { createContext, useContext } from "react";
import type { AuthenticatedUser } from "./session";

export const AuthenticatedUserContext =
  createContext<AuthenticatedUser | null>(null);

export const useAuthenticatedUser = () => useContext(AuthenticatedUserContext);
